<template>
  <div class="col-sm-12">
    <div class="section-panel public-gallery" :id="'TABLE-' + publicTable.TABLE_UUID">
      <div class="section-header">
        Public gallery
      </div>
      <div class="section-body">
        <div class="table-tools">
          <div class="table-search">
            <input type="text" class="form-control" placeholder="Search..." v-model="usersSearchQuery" />
            <a href="javascript:void(0);" @click="usersSearchQuery = ''" class="clear-search"
              ><i class="fa fa-times" aria-hidden="true"></i
            ></a>
          </div>
          <div class="table-pages" v-if="usersResult.length > pageSize">
            <pagination
              :page-size="pageSize"
              :current-page="currentPage"
              :total="usersResult.length"
              @pageChanged="changePage"
            ></pagination>
          </div>
        </div>
        <div class="users-cont">
          <div class="users-public">
            <ul class="guest-list">
              <div class="guest" v-for="user in pagedUsers" :key="'publicUser-' + user.userUUID">
                <person
                  :person="user"
                  :table-type="tableTypes.PUBLIC_GALLERY"
                  :options="{ company: true, title: true, actions: true }"
                ></person>
              </div>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Person from "@/components/DigitalEvent/RoomList/Room/People/Person";
import { mapGetters } from "vuex";
import { debounce, fieldComparator, getUserProperty, searchOverMultipleAttributes } from "@/helpers/helpers";
import Pagination from "@/modules/core/components/Pagination";
import { TABLE_TYPES } from "@/helpers/constants";

export default {
  name: "PublicGallery",
  data() {
    return {
      SEARCH_ATTRIBUTES: ["firstName", "lastName", "jobTitle", "company"],
      SORT_ATTRIBUTES: ["firstName", "lastName"],
      usersSearchQueryText: "",
      currentPage: 1
    };
  },
  components: {
    person: Person,
    pagination: Pagination
  },
  computed: {
    ...mapGetters({
      publicTable: "tables/publicTable"
    }),
    tableTypes() {
      return TABLE_TYPES;
    },
    usersSearchQuery: {
      get() {
        return this.usersSearchQueryText || "";
      },
      set: debounce(function(value) {
        this.currentPage = 1;
        this.usersSearchQueryText = value;
      }, 600)
    },
    tableUsers() {
      return this.$store.getters["tables/tableUsers"](this.publicTable.uuid);
    },

    pageSize() {
      return this.$store.state.event.config.defaultPaginationConfig &&
        this.$store.state.event.config.defaultPaginationConfig.publicUsers
        ? this.$store.state.event.config.defaultPaginationConfig.publicUsers
        : 50;
    },
    /**
     * Apply filtering (search) to users list
     * @return {Object[]}
     * @private
     */
    _filteredUsers() {
      return this.tableUsers.filter(user => {
        return searchOverMultipleAttributes(this.usersSearchQuery, getUserProperty(user, this.SEARCH_ATTRIBUTES));
      });
    },
    /**
     * Sorted users
     * @return {Object[]}
     */
    usersResult() {
      return [...this._filteredUsers].sort(fieldComparator(this.SORT_ATTRIBUTES, getUserProperty));
    },
    /**
     * Users on current page
     * @return {Object[]}
     */
    pagedUsers() {
      const startOffset = (this.currentPage - 1) * this.pageSize;
      return this.usersResult.slice(startOffset, startOffset + this.pageSize);
    }
  },
  methods: {
    /**
     * Change current page
     * @param pageNumber
     */
    changePage(pageNumber) {
      this.currentPage = pageNumber;
    }
  }
};
</script>
